/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ targets: NonNullable<unknown>, seconds: NonNullable<unknown> }} Draft_Dose_RestInputs */

const en_us2_draft_dose_rest = /** @type {(inputs: Draft_Dose_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.targets} · ${i?.seconds} s rest`)
};

const pt_br2_draft_dose_rest = /** @type {(inputs: Draft_Dose_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.targets} · ${i?.seconds} s de descanso`)
};

const es_419_draft_dose_rest = /** @type {(inputs: Draft_Dose_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.targets} · ${i?.seconds} s de descanso`)
};

const pt_pt2_draft_dose_rest = /** @type {(inputs: Draft_Dose_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.targets} · ${i?.seconds} s de descanso`)
};

const fr_fr2_draft_dose_rest = /** @type {(inputs: Draft_Dose_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.targets} · ${i?.seconds} s de repos`)
};

const de_de2_draft_dose_rest = /** @type {(inputs: Draft_Dose_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.targets} · ${i?.seconds} s Pause`)
};

const it_it2_draft_dose_rest = /** @type {(inputs: Draft_Dose_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.targets} · ${i?.seconds} s di recupero`)
};

/**
* | output |
* | --- |
* | "{targets} · {seconds} s rest" |
*
* @param {Draft_Dose_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_dose_rest = /** @type {((inputs: Draft_Dose_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Dose_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_dose_rest(inputs)
	if (locale === "es-419") return es_419_draft_dose_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_dose_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_dose_rest(inputs)
	if (locale === "de-DE") return de_de2_draft_dose_rest(inputs)
	if (locale === "it-IT") return it_it2_draft_dose_rest(inputs)
	return en_us2_draft_dose_rest(inputs)
});
export { draft_dose_rest as "draft.dose_rest" }